import {
  CancelSubscriptionFailureAction,
  CancelSubscriptionRequestAction,
  CancelSubscriptionSuccessAction,
  CurrentPlanData,
  GetCurrentPlanFailureAction,
  GetCurrentPlanRequestAction,
  GetCurrentPlanSuccessAction,
  GetPaymentUsageFailureAction,
  GetPaymentUsageRequestAction,
  GetPaymentUsageSuccessAction,
  PaymentUsageData,
  CreatePaymentFailureAction,
  CreatePaymentRequestAction,
  CreatePaymentSuccessAction,
  CustomerPortalFailureAction,
  CustomerPortalRequestAction,
  CustomerPortalSuccessAction,
  ClearPaymentStateAction,
  PaymentsActionTypes,
} from './payments.types';

export const createPaymentRequest = (
  product: string
): CreatePaymentRequestAction => ({
  type: PaymentsActionTypes.CREATE_PAYMENT_REQUEST,
  payload: { product },
});

export const createPaymentSuccess = (payload: {
  checkoutUrl?: string;
  message?: string;
  changeType?: string;
}): CreatePaymentSuccessAction => ({
  type: PaymentsActionTypes.CREATE_PAYMENT_SUCCESS,
  payload,
});

export const createPaymentFailure = (
  error: string
): CreatePaymentFailureAction => ({
  type: PaymentsActionTypes.CREATE_PAYMENT_FAILURE,
  payload: error,
});

export const getCurrentPlanRequest = (): GetCurrentPlanRequestAction => ({
  type: PaymentsActionTypes.GET_CURRENT_PLAN_REQUEST,
});

export const getCurrentPlanSuccess = (
  payload: CurrentPlanData
): GetCurrentPlanSuccessAction => ({
  type: PaymentsActionTypes.GET_CURRENT_PLAN_SUCCESS,
  payload,
});

export const getCurrentPlanFailure = (
  error: string
): GetCurrentPlanFailureAction => ({
  type: PaymentsActionTypes.GET_CURRENT_PLAN_FAILURE,
  payload: error,
});

export const getPaymentUsageRequest = (): GetPaymentUsageRequestAction => ({
  type: PaymentsActionTypes.GET_PAYMENT_USAGE_REQUEST,
});

export const getPaymentUsageSuccess = (
  payload: PaymentUsageData
): GetPaymentUsageSuccessAction => ({
  type: PaymentsActionTypes.GET_PAYMENT_USAGE_SUCCESS,
  payload,
});

export const getPaymentUsageFailure = (
  error: string
): GetPaymentUsageFailureAction => ({
  type: PaymentsActionTypes.GET_PAYMENT_USAGE_FAILURE,
  payload: error,
});

export const cancelSubscriptionRequest =
  (): CancelSubscriptionRequestAction => ({
    type: PaymentsActionTypes.CANCEL_SUBSCRIPTION_REQUEST,
  });

export const cancelSubscriptionSuccess = (
  status: string
): CancelSubscriptionSuccessAction => ({
  type: PaymentsActionTypes.CANCEL_SUBSCRIPTION_SUCCESS,
  payload: { status },
});

export const cancelSubscriptionFailure = (
  error: string
): CancelSubscriptionFailureAction => ({
  type: PaymentsActionTypes.CANCEL_SUBSCRIPTION_FAILURE,
  payload: error,
});

export const customerPortalRequest = (): CustomerPortalRequestAction => ({
  type: PaymentsActionTypes.CUSTOMER_PORTAL_REQUEST,
});

export const customerPortalSuccess = (
  checkoutUrl: string
): CustomerPortalSuccessAction => ({
  type: PaymentsActionTypes.CUSTOMER_PORTAL_SUCCESS,
  payload: { checkoutUrl },
});

export const customerPortalFailure = (
  error: string
): CustomerPortalFailureAction => ({
  type: PaymentsActionTypes.CUSTOMER_PORTAL_FAILURE,
  payload: error,
});

export const clearPaymentState = (): ClearPaymentStateAction => ({
  type: PaymentsActionTypes.CLEAR_PAYMENT_STATE,
});
